module.exports = __webpack_public_path__ + "static/media/YF75_02.97cc1221.jpg";